import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatNrComponent } from './mat-nr.component';



@NgModule({
  declarations: [MatNrComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [MatNrComponent],
})
export class MatNrModule { }
